import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';

export const GET_MINIMUM_USAGE_EXCEPTIONS = '@minimumUsageExceptions/get-minimum-usage-exceptions';
export const REQUEST_MINIMUM_USAGE_EXCEPTIONS = '@minimumUsageExceptions/request-minimum-usage-exceptions';

export function getMinimumUsageExceptions() {
  const request = axios.get(`${API_BASE_URL}/minimum-usage-exceptions`);

  return (dispatch) => {
    dispatch({ type: REQUEST_MINIMUM_USAGE_EXCEPTIONS });

    request
      .then((response) =>
        dispatch({
          type: GET_MINIMUM_USAGE_EXCEPTIONS,
          payload: { minimumUsageExceptions: response.data }
        })
      )
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = error.response.data;
        }
        dispatch({
          type: GET_MINIMUM_USAGE_EXCEPTIONS,
          payload: { minimumUsageExceptions: [], message }
        });
      });
  };
}
